export const slides = [
  {
    id: 'slide-1',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20rainy%20city%20street%20at%20night%20with%20deep%20navy%20blue%20and%20warm%20amber%20light%20reflections%20on%20wet%20asphalt%2C%20dramatic%20mood%20lighting%2C%20atmospheric%20fog%2C%20no%20text%2C%20no%20people%2C%20cinematic%20color%20grading%2C%20high%20detail%2C%20editorial%20composition&width=1600&height=900&seq=drama-hero-01&orientation=landscape',
    title: '我妻子的一切',
    subtitle: '都市情感悬疑大剧全线连载中，一段关于记忆与真相的漫长告白',
    type: 'tv',
    targetId: 'wo-qizi-de-yi-qie',
    badge: '热播剧集',
  },
  {
    id: 'slide-2',
    image: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20interior%20of%20an%20empty%20elegant%20living%20room%20at%20dusk%20with%20deep%20blue%20shadows%20and%20warm%20amber%20lamp%20glow%2C%20curtains%20moving%20in%20the%20wind%2C%20dramatic%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20style&width=1600&height=900&seq=drama-hero-02&orientation=landscape',
    title: '花絮 · 镜头背后的故事',
    subtitle: '走进片场，独家揭秘演员与幕后团队的真实日常',
    type: 'news',
    targetId: 'news-1',
    badge: '幕后花絮',
  },
  {
    id: 'slide-3',
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20shot%20of%20a%20quiet%20seaside%20pier%20at%20blue%20hour%20with%20deep%20navy%20sky%20and%20soft%20warm%20horizon%20light%2C%20gentle%20waves%2C%20melancholic%20mood%2C%20no%20text%2C%20no%20people%2C%20cinematic%20color%20grading%2C%20high%20detail%2C%20editorial%20film%20composition&width=1600&height=900&seq=drama-hero-03&orientation=landscape',
    title: '新剧《长夜将尽》',
    subtitle: '悬疑推理新作定档，一场跨越十年的真相追寻',
    type: 'tv',
    targetId: 'chang-ye-jiang-jin',
    badge: '最新上线',
  },
  {
    id: 'slide-4',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20shot%20of%20a%20sunlit%20old%20theatre%20stage%20with%20deep%20red%20curtains%20and%20amber%20spotlight%2C%20dust%20particles%20in%20the%20light%2C%20nostalgic%20mood%2C%20no%20text%2C%20no%20people%2C%20cinematic%20film%20photography%2C%20high%20detail%2C%20editorial%20composition&width=1600&height=900&seq=drama-hero-04&orientation=landscape',
    title: '《春日迟迟》温暖收官',
    subtitle: '口碑佳作迎来大结局，观众直呼后劲太足',
    type: 'news',
    targetId: 'news-2',
    badge: '资讯速递',
  },
];